import "./ProjectHeroMusicPlayerApp.scss";

function ProjectHeroMusicPlayerApp() {
  return (
    <>
      <section class="project-cs-hero">
        <div class="project-cs-hero__content">
          <h1 class="heading-primary">Music Player App</h1>
          <div class="project-cs-hero__info">
            <p class="text-primary text-primary--project">
              This is a website for a religious group to allow users to search,
              filter and play hymns / music.
            </p>
          </div>
          <div class="project-cs-hero__cta">
            <a
              href="https://preprod13kirtan.netlify.app/"
              class="btn btn--bg"
              target="_blank"
              rel="noreferrer"
            >
              Live Link
            </a>
          </div>
        </div>
      </section>
    </>
  );
}

export default ProjectHeroMusicPlayerApp;
